import { z } from 'zod/v4';
import type { TypedSupabaseClient } from '../client';
import type { DocumentAccessSettings, DocumentCreator } from '../../../interfaces/src';

const settingsSchema = z.object({
  showDocumentCreatorToTeam: z.boolean(),
  canViewDocumentCreator: z.boolean(),
});
const creatorsSchema = z.array(z.object({
  documentId: z.string().uuid(), userId: z.string().uuid(),
  displayName: z.string(), avatarUrl: z.string().nullable(),
}));

// RPC contracts are validated at the adapter boundary until generated types
// include the corresponding additive migration.
interface AccessRpcClient {
  rpc(name: string, args?: Record<string, unknown>): Promise<{data: unknown; error: {message: string} | null}>;
}
export async function readDocumentAccessSettings(client: TypedSupabaseClient): Promise<DocumentAccessSettings> {
  const { data, error } = await (client as unknown as AccessRpcClient).rpc('get_document_access_settings');
  if (error) throw new Error(error.message);
  return settingsSchema.parse(data);
}
export async function writeDocumentAccessSettings(client: TypedSupabaseClient, input: Pick<DocumentAccessSettings, 'showDocumentCreatorToTeam'>): Promise<DocumentAccessSettings> {
  const valid = z.object({showDocumentCreatorToTeam: z.boolean()}).strict().parse(input);
  const {data,error} = await (client as unknown as AccessRpcClient).rpc('set_document_access_settings', { p_show_creator_to_team: valid.showDocumentCreatorToTeam });
  if (error) throw new Error(error.message);
  return settingsSchema.parse(data);
}
export async function readDocumentCreators(client: TypedSupabaseClient, family: 'sales' | 'purchases', ids: string[]): Promise<DocumentCreator[]> {
  const input = z.object({family:z.enum(['sales','purchases']),ids:z.array(z.string().uuid()).max(500)}).parse({family,ids});
  if (input.ids.length === 0) return [];
  const {data,error} = await (client as unknown as AccessRpcClient).rpc('get_document_creators', {p_family:input.family,p_document_ids:[...new Set(input.ids)]});
  if (error) throw new Error(error.message);
  return creatorsSchema.parse(data ?? []);
}
